import { render } from "./RecordsLocation.vue?vue&type=template&id=41c35f24"
import script from "./RecordsLocation.vue?vue&type=script&lang=js"
export * from "./RecordsLocation.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__